import { Component, OnInit } from '@angular/core';
import { BaseComponent, UtilsArray, UtilsMisc, UtilsString } from '@pit/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { PinItTrackFrontendServicesAccessor } from '../../module.core/accessor/implementations/pin.it.track.frontend.services.accessor';

@Component({
    selector: 'pin-it-track-frontend-message-dialog',
    templateUrl: './pin.it.track.frontend.message.dialog.component.html',
    styleUrls: ['./pin.it.track.frontend.message.dialog.component.scss']
})
export class PinItTrackFrontendMessageDialogComponent extends BaseComponent {

    constructor(private servicesAccessor: PinItTrackFrontendServicesAccessor, private dialogRef: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {
        super(servicesAccessor.coreServicesAccessor.applicationService);
    }

    public get canSave(): boolean {
        return (UtilsString.stringIsNullOrEmpty(this.message) === false);
    }

    public message: string = null;

    public async cancelAsync(): Promise<void> {
        this.dialogRef.close();
    }

    public async saveAsync(): Promise<void> {
        try {
            this.dialogRef.close(this.message);
        } catch (error) {
        } finally {
        }
    }

}
